/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useState, useRef, useEffect } from "react";
import { History, MoreVertical, Edit } from "lucide-react";
import TableLazyImage from "./TableLazyImage";

const BookingsTable = ({
  bookings,
  loading,
  getStatusColor,
  currency,
  onViewHistory,
  onUpdateBooking,
}) => {
  const [openMenuId, setOpenMenuId] = useState(null);
  const menuRefs = useRef({});

  // Close menu
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (openMenuId && menuRefs.current[openMenuId]) {
        if (!menuRefs.current[openMenuId].contains(event.target)) {
          setOpenMenuId(null);
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openMenuId]);

  const toggleMenu = (id) => {
    setOpenMenuId(openMenuId === id ? null : id);
  };

  if (loading) {
    return (
      <tr>
        <td
          colSpan={6}
          className="px-6 py-12 text-center text-gray-500 dark:text-dark-muted"
        >
          <div className="flex justify-center">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
          </div>
        </td>
      </tr>
    );
  }

  if (bookings.length === 0) {
    return (
      <tr>
        <td
          colSpan={6}
          className="px-6 py-12 text-center text-gray-500 dark:text-dark-muted"
        >
          No bookings found.
        </td>
      </tr>
    );
  }

  return bookings.map((b) => (
    <tr
      key={b.id}
      className="hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors relative"
    >
      <td className="px-6 py-4">
        <div className="flex items-center gap-3">
          <div className="relative w-10 h-10">
            <TableLazyImage
              src={b.client.avatar}
              alt={b.client.name}
              size={10}
            />
          </div>
          <div>
            <p className="text-sm font-bold text-text dark:text-dark-text">
              {b.client.name}
            </p>
            <p className="text-xs text-gray-500 dark:text-dark-muted">
              {b.client.phone}
            </p>
          </div>
        </div>
      </td>
      <td className="px-6 py-4 text-sm text-gray-600 dark:text-dark-muted">
        {b.dateTime}
      </td>
      <td className="px-6 py-4">
        <div className="flex items-center gap-3">
          <div className="relative w-8 h-8">
            <TableLazyImage
              src={b.caregiver.avatar}
              alt={b.caregiver.name}
              size={8}
            />
          </div>
          <p className="text-sm font-medium text-text dark:text-dark-text">
            {b.caregiver.name}
          </p>
        </div>
      </td>
      <td className="px-6 py-4 text-sm font-bold text-text dark:text-dark-text">
        {currency} {b.salary}
      </td>
      <td className="px-6 py-4">
        <div className="flex items-center gap-2">
          <span
            className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium border ${getStatusColor(
              b.status,
            )}`}
          >
            {b.status}
          </span>
          {b.userData?.hasActiveJobInCategory &&
            (b.status === "New" || b.status === "In_Progress") && (
              <span
                className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-400 border border-orange-200 dark:border-orange-800"
                title="Client has an active job in this category"
              >
                Active Job
              </span>
            )}
        </div>
      </td>
      <td className="px-6 py-4">
        <div
          className="flex items-center justify-center"
          ref={(el) => (menuRefs.current[b.id] = el)}
        >
          <button
            onClick={() => toggleMenu(b.id)}
            className="p-1.5 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors text-gray-500 dark:text-dark-muted hover:text-gray-700 dark:hover:text-dark-text"
            aria-label="Actions menu"
          >
            <MoreVertical size={18} />
          </button>

          {/* Dropdown Menu */}
          {openMenuId === b.id && (
            <div className="absolute right-6 mt-10 z-50 w-48 bg-white dark:bg-dark-surface rounded-lg shadow-lg border border-gray-200 dark:border-dark-border py-1 animate-in fade-in slide-in-from-top-2 duration-200">
              <button
                onClick={() => {
                  onViewHistory(b);
                  setOpenMenuId(null);
                }}
                className="w-full px-4 py-2.5 text-sm text-gray-700 dark:text-dark-text hover:bg-gray-50 dark:hover:bg-gray-800 flex items-center gap-2 transition-colors"
              >
                <History
                  size={16}
                  className="text-blue-500 dark:text-blue-400"
                />
                <span>View History</span>
              </button>
              <button
                onClick={() => {
                  onUpdateBooking(b);
                  setOpenMenuId(null);
                }}
                className="w-full px-4 py-2.5 text-sm text-gray-700 dark:text-dark-text hover:bg-gray-50 dark:hover:bg-gray-800 flex items-center gap-2 transition-colors"
              >
                <Edit
                  size={16}
                  className="text-primary dark:text-dark-accent"
                />
                <span>Update</span>
              </button>
            </div>
          )}
        </div>
      </td>
    </tr>
  ));
};

export default BookingsTable;
